export default "__VITE_ASSET__dc106b6d__"